import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import './TermsModal.scss';
import closeIcon from "../../../../../Assets/images/modal-close.svg"

const TermsModal = ({ isOpen, onClose, onAccept, onDecline }) => {
  if (!isOpen) return null;

  return (
    <div className="terms-overlay">
      <div className="terms-modal">
        <div className="terms-header">
          <h5>Terms and Conditions</h5>
          <button onClick={onClose} className="close-btn">
              <img src={closeIcon} alt="Close" />
          </button>
        </div>

        <div className="terms-body pdf-viewer">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
           <Viewer fileUrl={`${process.env.REACT_APP_SERVER_BASE_URL}/downloads/CC_Terms_and_Conditions.pdf`}  />
          </Worker>
        </div>

        <div className="terms-footer">
          <button className="btn-decline" onClick={onDecline}>Decline</button>
          <button className="btn-accept" onClick={onAccept}>Accept</button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
